import script from "./ChatPrintPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPrintPage.vue?vue&type=script&setup=true&lang=js"

import "./ChatPrintPage.vue?vue&type=style&index=0&id=12891336&lang=css"

const __exports__ = script;

export default __exports__